import { useEffect } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import Layout from "../../Authentication/Layout";
import { PAGE_TITLE } from "./messages";

function PageShell({ title, children }) {
	useEffect(() => {
		const previousTitle = document.title;
		document.title = PAGE_TITLE;
		return () => {
			document.title = previousTitle;
		};
	}, []);

	return (
		<Layout image="/assets/images/background.png">
			<Card className="shadow-none bg-transparent mt-5 mx-auto" style={{ maxWidth: 480 }}>
				<CardBody>
					{title && (
						<CardTitle tag="h1" className="h3 font-weight-bolder mb-3">
							{title}
						</CardTitle>
					)}
					{children}
				</CardBody>
			</Card>
		</Layout>
	);
}

export default PageShell;
